var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScheduleNewActiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1959_124066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83331 1.16675L5.83331 3.16675M11.1666 1.16675V3.16675M11.8333 5.83342H5.16665M8.23331 15.1667H8.76665C11.0069 15.1667 12.127 15.1667 12.9826 14.7308C13.7353 14.3473 14.3472 13.7354 14.7307 12.9827C15.1666 12.1271 15.1666 11.007 15.1666 8.76675V8.23342C15.1666 5.9932 15.1666 4.8731 14.7307 4.01745C14.3472 3.2648 13.7353 2.65288 12.9826 2.26939C12.127 1.83341 11.0069 1.83341 8.76665 1.83341H8.23331C5.9931 1.83341 4.873 1.83341 4.01735 2.26939C3.2647 2.65288 2.65278 3.2648 2.26929 4.01745C1.83331 4.8731 1.83331 5.9932 1.83331 8.23341V8.76675C1.83331 11.007 1.83331 12.1271 2.26929 12.9827C2.65278 13.7354 3.2647 14.3473 4.01735 14.7308C4.873 15.1667 5.9931 15.1667 8.23331 15.1667Z",
    stroke: "#4D6EF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1959_124066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleNewActiveIcon);
export default __webpack_public_path__ + "static/media/Schedule_new_active_icon.2c2fd81e.svg";
export { ForwardRef as ReactComponent };